import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      title: "Servicing",
      description: "Regular servicing keeps your garage door safe, smooth, and reliable. It helps prevent costly breakdowns, extends the lifespan of parts, improves security, and gives you peace of mind every time you use it.",
      image: "https://images.squarespace-cdn.com/content/v1/68974af92a7345610c4b9264/2aaa11e3-c2e2-41aa-9d48-307416b8ab86/How-To-Lubricate-Your-Garage-Door.jpg",
      link: "/servicing",
    },
    {
      title: "Repairs",
      description: "Fast, reliable fixes for stuck, noisy, or damaged garage doors. We repair most makes and models, restoring smooth operation, safety, and security in no time.",
      image: "https://images.squarespace-cdn.com/content/v1/68974af92a7345610c4b9264/70fa2be7-10a8-4cee-8c3f-c60cc33c427f/Untitled.png",
      link: "/repairs",
    },
    {
      title: "Automation",
      description: "Upgrade your garage with smart automation for effortless access and enhanced security. Open and close your door at the touch of a button with reliable systems designed for convenience and peace of mind.",
      image: "https://images.squarespace-cdn.com/content/v1/68974af92a7345610c4b9264/355cc40a-cc72-4b71-987f-bf6ce42e0136/LM80.jpg",
      link: "/automation",
    },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">Our Services</h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link 
              key={index} 
              to={service.link}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-xl mb-6 aspect-[4/3]">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  width={640}
                  height={480}
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/60 to-transparent" />
                <h3 className="absolute bottom-4 left-4 text-2xl md:text-3xl font-bold text-background">
                  {service.title}
                </h3>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                {service.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
